import React from 'react';


import { Link } from 'react-router-dom';

import { Button } from '@shared/components/ui';
import { Z } from '@shared/constants/zIndex';

const HOME_LOGO = '/icons/conway-512.png';

const LandingNav: React.FC = () => {
  return (
    <nav className="bg-muted/80 dark:bg-background/80 sticky top-0 backdrop-blur-sm" style={{ zIndex: Z.STICKY }}>
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2">
          {/* Rounded: the mark is a full-bleed maskable tile, not the
              transparent badge this slot used to hold. */}
          <img src={HOME_LOGO} alt="Conway" className="h-8 w-8 rounded-[22%]" />
          <span className="text-foreground text-xl font-light">Conway</span>
        </Link>
        <Link to="/signin">
          <Button variant="ghost" size="sm">
            Sign In
          </Button>
        </Link>
      </div>
    </nav>
  );
};

export default LandingNav;
